import React from 'react';
import { useSelector } from 'react-redux';
import useFetchCurrentStatus from '../StatusChange/hooks/useFetchCurrentStatus';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import { selectDealer } from '../../core/reducers/dealer';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../core/reducers/vehicles';
import { ACURA_SITE_NAME, HONDA_SITE_NAME } from '../../utils/constants';
import { createObjectFromProps } from '../../utils/object';
import { useAppName } from '../../utils/sitecoreContext';
import NotImplemented from '../NotImplemented';
import { useAppSelector } from '../../core/utils';
import LeadsCtasUI from './LeadsCtasUI';
import mapFields from './utils';
const LeadsCtas = ({ rendering, fields }) => {
    var _a;
    const appName = useAppName();
    const { modelKey, modelYear, trimKey, transmissionKey, exteriorColorKey, interiorColorKey } = useSelector(selectCurrentVehicle);
    const { dealerCode = '' } = useSelector(selectDealer);
    const gtmBodyStyle = useSelector(selectBodyTypesForGtm);
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const params = [
        { key: 'model', value: modelKey },
        { key: 'modelYear', value: modelYear },
        { key: 'trim', value: trimKey },
        { key: 'transmission', value: transmissionKey },
        { key: 'exteriorColor', value: exteriorColorKey },
        { key: 'interiorColor', value: interiorColorKey },
        { key: 'dealerCode', value: dealerCode },
    ];
    const { data: inventoryStatus } = useFetchCurrentStatus();
    if (!fields)
        return null;
    const mappedFields = mapFields(createObjectFromProps(fields), params);
    switch (appName) {
        case ACURA_SITE_NAME:
        case HONDA_SITE_NAME:
            break;
        default:
            return React.createElement(NotImplemented, { name: "Leads CTAs " });
    }
    return (React.createElement(LeadsCtasUI, { fields: mappedFields, title: mappedFields.title, inventoryAvailabilityStatus: inventoryStatus, model: modelKey, trim: (_a = currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName) !== null && _a !== void 0 ? _a : '', componentType: rendering === null || rendering === void 0 ? void 0 : rendering.componentName, bodyStyle: gtmBodyStyle }));
};
export default LeadsCtas;
